module.exports = __webpack_public_path__ + "dbe7bace32339334586636c82ed9d649.fbx";